<template>
  <div class="riddle-game">
    <AppHeader />
    
    <div class="game-container">
      <RiddleCard
        v-if="currentRiddle"
        :riddle="currentRiddle"
        :showAnswer="showAnswer"
      />
      
      <GameNavigation
        :hasPrev="currentIndex > 0"
        :hasNext="currentIndex < riddles.length - 1"
        :showAnswer="showAnswer"
        @prev="prevRiddle"
        @next="nextRiddle"
        @toggle-answer="toggleAnswer"
      />
    </div>
    
    <PromoButton @open-promo="showModal = true" />
    
    <MiniProgramModal 
      :show="showModal"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import riddlesData from '@/assets/riddles_1783950373611.json'
import AppHeader from './Header.vue'
import RiddleCard from './RiddleCard.vue'
import GameNavigation from './Navigation.vue'
import PromoButton from './PromoButton.vue'
import MiniProgramModal from './MiniProgramModal.vue'

export default {
  name: 'RiddleGame',
  components: {
    AppHeader,
    RiddleCard,
    GameNavigation,
    PromoButton,
    MiniProgramModal
  },
  data() {
    return {
      riddles: [],
      currentIndex: 0,
      showAnswer: false,
      showModal: false
    }
  },
  computed: {
    currentRiddle() {
      return this.riddles[this.currentIndex] || null
    }
  },
  created() {
    this.riddles = riddlesData.filter(r => r.question && r.answer)
  },
  methods: {
    toggleAnswer() {
      this.showAnswer = true
    },
    prevRiddle() {
      if (this.currentIndex > 0) {
        this.currentIndex--
        this.showAnswer = false
      }
    },
    nextRiddle() {
      if (this.currentIndex < this.riddles.length - 1) {
        this.currentIndex++
        this.showAnswer = false
      } else {
        // 最后一题，点击下一题显示弹窗
        this.showModal = true
      }
    }
  }
}
</script>

<style src="@/styles/RiddleGame.css"></style>
